/* Site-Specific JavaScript */
document.addEventListener('DOMContentLoaded', function () {
    if (typeof AOS !== 'undefined') {
        AOS.refresh();
    }

    const footnotes = new EqFootnote();

    document.querySelectorAll('.documents-resources .c-cms-list_wrap').forEach(function (wrapper) {
        const items = Array.from(wrapper.querySelectorAll('.c-cms-list_item'));
        const toggleBtn = wrapper.querySelector('.c-cms-list_load-btn');
        const labelEl = toggleBtn ? toggleBtn.querySelector('.t-btn') : null;
        const arrowEl = toggleBtn ? toggleBtn.querySelector('.c-sms-list_btn-arrows') : null;
        const moreLabel = toggleBtn ? toggleBtn.getAttribute('data-more-label') || '' : '';
        const lessLabel = toggleBtn ? toggleBtn.getAttribute('data-less-label') || 'View less' : 'View less';
        let expanded = false;

        function getInitialCount() {
            return window.innerWidth >= 768 ? 5 : 3;
        }

        function getFirstRevealedLink() {
            const firstExtra = items[getInitialCount()];
            if (!firstExtra || firstExtra.hidden) {
                return null;
            }
            return firstExtra.querySelector('a.c-cms-list_title') || firstExtra.querySelector('a');
        }

        function focusControl(el) {
            if (!el || typeof el.focus !== 'function') {
                return;
            }
            try {
                el.focus({ preventScroll: true, focusVisible: true });
            } catch (err) {
                el.focus();
            }
        }

        function updateList() {
            const initialCount = getInitialCount();
            items.forEach(function (item, index) {
                const collapsedHidden = !expanded && index >= initialCount;
                item.hidden = collapsedHidden;
                item.classList.toggle('is-collapsed-hidden', collapsedHidden);
                item.classList.remove('is-last-visible');
            });
            const visible = items.filter(function (item) {
                return !item.hidden;
            });
            if (visible.length) {
                visible[visible.length - 1].classList.add('is-last-visible');
            }
            if (items.length <= initialCount) {
                wrapper.classList.add('is-short');
                wrapper.classList.remove('is-expanded');
            } else {
                wrapper.classList.remove('is-short');
                wrapper.classList.toggle('is-expanded', expanded);
            }
            if (toggleBtn) {
                toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                if (labelEl) {
                    labelEl.textContent = expanded ? lessLabel : moreLabel;
                }
                if (arrowEl) {
                    arrowEl.classList.toggle('is-up', expanded);
                }
            }
            if (typeof AOS !== 'undefined') {
                AOS.refresh();
            }
        }

        if (toggleBtn) {
            toggleBtn.addEventListener('click', function () {
                expanded = !expanded;
                updateList();
            });

            toggleBtn.addEventListener('keydown', function (e) {
                if (e.key !== 'Tab' || e.shiftKey || !expanded) {
                    return;
                }
                const firstRevealed = getFirstRevealedLink();
                if (!firstRevealed) {
                    return;
                }
                e.preventDefault();
                focusControl(firstRevealed);
            });
        }

        wrapper.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab' || !e.shiftKey || !expanded) {
                return;
            }
            const firstRevealed = getFirstRevealedLink();
            if (!firstRevealed || e.target !== firstRevealed) {
                return;
            }
            e.preventDefault();
            focusControl(toggleBtn);
        });

        updateList();

        let wasDesktop = window.innerWidth >= 768;
        window.addEventListener('resize', function () {
            const isDesktop = window.innerWidth >= 768;
            if (isDesktop !== wasDesktop) {
                expanded = false;
                wasDesktop = isDesktop;
                updateList();
            }
        });
    });
});
